import { useState } from 'react'
import { Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog'
import { useDeleteFeatureFlag } from '@/hooks/use-feature-flags'
import type { FeatureFlagDTO } from '@/schemas/feature-flag.schema'

export function DeleteFeatureFlagButton({
  flag,
  onDeleted,
}: {
  flag: FeatureFlagDTO
  onDeleted: () => void
}) {
  const [confirming, setConfirming] = useState(false)
  const mutation = useDeleteFeatureFlag(onDeleted)
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="ff-delete-button"
        onClick={() => setConfirming(true)}
      >
        <Trash2 size={14} />
        Delete flag
      </Button>
      <Dialog
        open={confirming}
        onOpenChange={(open) => {
          if (!mutation.isPending) {
            setConfirming(open)
          }
        }}
      >
        {/* The create dialog's frame, so both dialogs look alike. */}
        <DialogContent
          className="ff-console ff-create-dialog"
          showCloseButton={!mutation.isPending}
        >
          <header className="ff-detail-header">
            <div className="ff-title-row">
              <DialogTitle>Delete {flag.name}?</DialogTitle>
            </div>
            <DialogDescription className="ff-intro">
              Code that still reads <code>{flag.key}</code> gets the flag as
              off, for everyone. Remove the check from the code first. The key
              cannot be used again.
            </DialogDescription>
          </header>
          <footer className="ff-savebar">
            <span />
            <div>
              <Button
                variant="ghost"
                size="sm"
                disabled={mutation.isPending}
                onClick={() => setConfirming(false)}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                size="sm"
                disabled={mutation.isPending}
                onClick={() => mutation.mutate(flag.key)}
              >
                {mutation.isPending ? 'Deleting…' : 'Delete'}
              </Button>
            </div>
          </footer>
        </DialogContent>
      </Dialog>
    </>
  )
}
